export class Css {
  Id?: string;
  ClassNames?: string;
  Changed: boolean = false;
}
